import React from 'react'
import { useTranslation } from 'react-i18next'
import toast from 'react-hot-toast'
import { FlexibleModal, Button } from 'components'
import GroupSearchTable from 'containers/ObjectTables/GroupSearchTable'
import ApiHelper from 'helpers/ApiHelper'

const GroupAccessModal = ({ objectIds, visible, toggle, onDone }) => {
  const { t } = useTranslation()

  const onAddGroupBulk = async ({ groupId }) => {
    await toast.promise(ApiHelper.bulkAddGroupAccess(groupId, objectIds()), {
      loading: 'Creating access...',
      success: 'Group access updated.',
      error: 'Could not add group access.',
    })

    onDone()
  }

  return (
    <FlexibleModal size="modal-md" visible={visible}>
      <div className="flex flex-col space-y-2">
        <GroupSearchTable id="add-access-bulk" onSubmit={onAddGroupBulk} />
        <div className="flex justify-end pt-10">
          <Button onClick={toggle}>{t('application:cancel')}</Button>
        </div>
      </div>
    </FlexibleModal>
  )
}

export default GroupAccessModal
